export default __webpack_public_path__ + "static/media/754.41e7c539.jpg";